/**
 * @fileoverview gRPC-Web generated client stub for qowner.erp.api.v1.services
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.20.3
// source: projects/erp/service/api/v1/services/customers.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js')

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var google_protobuf_field_mask_pb = require('google-protobuf/google/protobuf/field_mask_pb.js')

var projects_erp_service_api_v1_model_customer_pb = require('./customer_pb.js')
const proto = {};
proto.qowner = {};
proto.qowner.erp = {};
proto.qowner.erp.api = {};
proto.qowner.erp.api.v1 = {};
proto.qowner.erp.api.v1.services = require('./customers_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.qowner.erp.api.v1.services.CustomersClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.qowner.erp.api.v1.services.CustomersPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.qowner.erp.api.v1.services.ListCustomersRequest,
 *   !proto.qowner.erp.api.v1.services.ListCustomersResponse>}
 */
const methodDescriptor_Customers_ListCustomers = new grpc.web.MethodDescriptor(
  '/qowner.erp.api.v1.services.Customers/ListCustomers',
  grpc.web.MethodType.UNARY,
  proto.qowner.erp.api.v1.services.ListCustomersRequest,
  proto.qowner.erp.api.v1.services.ListCustomersResponse,
  /**
   * @param {!proto.qowner.erp.api.v1.services.ListCustomersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.qowner.erp.api.v1.services.ListCustomersResponse.deserializeBinary
);


/**
 * @param {!proto.qowner.erp.api.v1.services.ListCustomersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.qowner.erp.api.v1.services.ListCustomersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.qowner.erp.api.v1.services.ListCustomersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.qowner.erp.api.v1.services.CustomersClient.prototype.listCustomers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/qowner.erp.api.v1.services.Customers/ListCustomers',
      request,
      metadata || {},
      methodDescriptor_Customers_ListCustomers,
      callback);
};


/**
 * @param {!proto.qowner.erp.api.v1.services.ListCustomersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.qowner.erp.api.v1.services.ListCustomersResponse>}
 *     Promise that resolves to the response
 */
proto.qowner.erp.api.v1.services.CustomersPromiseClient.prototype.listCustomers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/qowner.erp.api.v1.services.Customers/ListCustomers',
      request,
      metadata || {},
      methodDescriptor_Customers_ListCustomers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.qowner.erp.api.v1.services.GetCustomerRequest,
 *   !proto.qowner.erp.api.v1.model.Customer>}
 */
const methodDescriptor_Customers_GetCustomer = new grpc.web.MethodDescriptor(
  '/qowner.erp.api.v1.services.Customers/GetCustomer',
  grpc.web.MethodType.UNARY,
  proto.qowner.erp.api.v1.services.GetCustomerRequest,
  projects_erp_service_api_v1_model_customer_pb.Customer,
  /**
   * @param {!proto.qowner.erp.api.v1.services.GetCustomerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  projects_erp_service_api_v1_model_customer_pb.Customer.deserializeBinary
);


/**
 * @param {!proto.qowner.erp.api.v1.services.GetCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.qowner.erp.api.v1.model.Customer)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.qowner.erp.api.v1.model.Customer>|undefined}
 *     The XHR Node Readable Stream
 */
proto.qowner.erp.api.v1.services.CustomersClient.prototype.getCustomer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/qowner.erp.api.v1.services.Customers/GetCustomer',
      request,
      metadata || {},
      methodDescriptor_Customers_GetCustomer,
      callback);
};


/**
 * @param {!proto.qowner.erp.api.v1.services.GetCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.qowner.erp.api.v1.model.Customer>}
 *     Promise that resolves to the response
 */
proto.qowner.erp.api.v1.services.CustomersPromiseClient.prototype.getCustomer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/qowner.erp.api.v1.services.Customers/GetCustomer',
      request,
      metadata || {},
      methodDescriptor_Customers_GetCustomer);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.qowner.erp.api.v1.services.ApplyCustomerRequest,
 *   !proto.qowner.erp.api.v1.model.Customer>}
 */
const methodDescriptor_Customers_ApplyCustomer = new grpc.web.MethodDescriptor(
  '/qowner.erp.api.v1.services.Customers/ApplyCustomer',
  grpc.web.MethodType.UNARY,
  proto.qowner.erp.api.v1.services.ApplyCustomerRequest,
  projects_erp_service_api_v1_model_customer_pb.Customer,
  /**
   * @param {!proto.qowner.erp.api.v1.services.ApplyCustomerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  projects_erp_service_api_v1_model_customer_pb.Customer.deserializeBinary
);


/**
 * @param {!proto.qowner.erp.api.v1.services.ApplyCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.qowner.erp.api.v1.model.Customer)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.qowner.erp.api.v1.model.Customer>|undefined}
 *     The XHR Node Readable Stream
 */
proto.qowner.erp.api.v1.services.CustomersClient.prototype.applyCustomer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/qowner.erp.api.v1.services.Customers/ApplyCustomer',
      request,
      metadata || {},
      methodDescriptor_Customers_ApplyCustomer,
      callback);
};


/**
 * @param {!proto.qowner.erp.api.v1.services.ApplyCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.qowner.erp.api.v1.model.Customer>}
 *     Promise that resolves to the response
 */
proto.qowner.erp.api.v1.services.CustomersPromiseClient.prototype.applyCustomer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/qowner.erp.api.v1.services.Customers/ApplyCustomer',
      request,
      metadata || {},
      methodDescriptor_Customers_ApplyCustomer);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.qowner.erp.api.v1.services.DeleteCustomerRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Customers_DeleteCustomer = new grpc.web.MethodDescriptor(
  '/qowner.erp.api.v1.services.Customers/DeleteCustomer',
  grpc.web.MethodType.UNARY,
  proto.qowner.erp.api.v1.services.DeleteCustomerRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.qowner.erp.api.v1.services.DeleteCustomerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.qowner.erp.api.v1.services.DeleteCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.qowner.erp.api.v1.services.CustomersClient.prototype.deleteCustomer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/qowner.erp.api.v1.services.Customers/DeleteCustomer',
      request,
      metadata || {},
      methodDescriptor_Customers_DeleteCustomer,
      callback);
};


/**
 * @param {!proto.qowner.erp.api.v1.services.DeleteCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.qowner.erp.api.v1.services.CustomersPromiseClient.prototype.deleteCustomer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/qowner.erp.api.v1.services.Customers/DeleteCustomer',
      request,
      metadata || {},
      methodDescriptor_Customers_DeleteCustomer);
};


module.exports = proto.qowner.erp.api.v1.services;

